
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 3a5 5 0 100 10A5 5 0 008 3zm.833 3.495a.52.52 0 110 1.041H7.012a.104.104 0 00-.104.094 3.838 3.838 0 00-.015.518c.002.056.048.1.104.1h1.324a.52.52 0 110 1.042h-.95a.104.104 0 00-.084.166c.403.51 1.133.73 2.282.73a.52.52 0 110 1.041c-.767 0-2.83-.008-3.5-1.87a.105.105 0 00-.099-.07h-.357a.52.52 0 010-1.041h.137a.105.105 0 00.104-.112 1.76 1.76 0 01-.006-.136c0-.125.007-.239.016-.351a.104.104 0 00-.104-.113h-.13a.52.52 0 010-1.042h.417a.104.104 0 00.095-.061c.746-1.66 2.691-1.66 3.428-1.66a.52.52 0 010 1.042c-.958 0-1.622.152-2.05.496a.104.104 0 00.063.186h1.25z","fill":"#003653","fill-rule":"evenodd"}})])
          )
        }
      }
    